import React from 'react';
import { Navigate } from 'react-router-dom';
import authTokenUtil from '../../account/authTokenUtil';
import useAppSelector from '../redux/useAppSelector';
import { UserType } from '../../graphql/generated/graphql';

interface EnsureLoggedOutProps {
  children: JSX.Element;
}

const EnsureLoggedOut = ({ children }: EnsureLoggedOutProps) => {
  const user = useAppSelector((state) => state.session.user);

  if ((user.id && user.type !== UserType.Visitor) || authTokenUtil.get()) {
    const url = new URL(window.location.href);

    return <Navigate to={url.searchParams.get('redirect') || '/'} replace />;
  }

  return children;
};

export default EnsureLoggedOut;
